// ErrorMessageWithIcon.tsx
import React from "react";
import { ErrorMessage } from "formik";
import { ReactComponent as WarningIcon } from "../../icons/warning.svg";
import styles from "./Orders.module.scss";

interface ErrorMessageWithIconProps {
  name: string;
  className?: string;
}

const ErrorMessageWithIcon: React.FC<ErrorMessageWithIconProps> = ({
  name,
  className,
}) => (
  <ErrorMessage
    name={name}
    render={(msg) => (
      <div className={`${styles.errorContainer} ${className}`}>
        <div className={styles.iconContainer}>
          <WarningIcon className={styles.errorIcon} />
        </div>
        <div>{msg}</div>
      </div>
    )}
  />
);

export default ErrorMessageWithIcon;
